<template>
  <div class="client-step-four_block">
    <div class="left">
      <h3 class="large_blue_label">4. 契約・決済</h3>
      <p>打合せで双方が合意しましたら、<span class="marker-underline_label">それぞれ「発注」ボタン、「受注」ボタンを押して頂きます。</span></p>
      <p>後々のトラブル防止のために、クライアントは契約内容を踏まえて注文書を作成、アップロード頂きます。</p>
      <p>フルーでは注文書のひな型を提供していますので、そちらを適宜修正してご利用頂くことも可能です。</p>
      <br>
      <p class="marker-underline_label">クライアントには続けて仮決済を行って頂きます。</p>
      <p>仮決済とは、作業着手前にフルーがクライアントから一時的に発注金額を預かることを指します。</p>
      <p>なお、クライアントのアカウントが従業員アカウントの場合、決済権限を持っている上長に仮決済依頼のメール通知が届きます。上長の方は速やかに仮決済を完了させてください。フルーが預かった発注金額はクライアントが検収をした後、所定の手数料を差し引いてオペレーターへ送金します。このシステムにより、クライアントとオペレーターの双方が安心して決済を行うことができます。</p>
      <br>
      <p class="marker-underline_label">仮決済が完了しますと、オペレーターが作業を開始します。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/cl_five_steps_4.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ClientStepFourBlock"
  }
</script>

<style lang="scss" scoped>
  .client-step-four_block {
    @include double_columns(40%, 35%);

    .large_blue_label {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>